import React from "react";
import { StatCard, DonutWithLegend } from "@/components/ui";
import { Activity, UserPlus, UserCheck, Calendar } from 'lucide-react';

export const ActivityStats = ({ stats, isExpanded, onToggle, dateRangeLabel = "This Period", selectedStatus = "all" }) => {
  const {
    created = 0,
    assigned = 0,
    converted = 0,
    totalActivities = 0,
    activityBreakdown = []
  } = stats || {};

  const getDynamicTitle = () => {
    if (!selectedStatus || selectedStatus === 'all') return "Contacts Created";
    if (selectedStatus === 'assigned') return "Assigned";
    // Format label (e.g., 'contact_later' -> 'Contact Later')
    return selectedStatus.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  };

  const isDefault = !selectedStatus || selectedStatus === 'all';

  return (
    <div className="space-y-4 relative group/activity-stats">
      <div className="flex items-center justify-between px-1">
        <h3 className="text-sm font-semibold text-slate-700 flex items-center gap-2">
          <Activity size={16} className="text-brand-blue" />
          Activity Overview <span className="text-[11px] font-normal text-slate-400">({dateRangeLabel})</span>
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 auto-rows-fr">
        {/* Dynamic Activity Card - Now the primary focus */}
        <StatCard
          variant="dashboard"
          title={getDynamicTitle()}
          value={isDefault ? created : assigned}
          color={isDefault ? "bg-brand-blue" : "bg-purple-500"}
          isExpanded={isExpanded}
          icon={isDefault ? <UserPlus size={20} /> : <UserCheck size={20} />}
          description={
            isDefault
              ? `New records added in ${dateRangeLabel}`
              : selectedStatus === 'assigned'
                ? `Assigned to team in ${dateRangeLabel}`
                : `Reached ${getDynamicTitle()} in ${dateRangeLabel}`
          }
        />
      </div>
    </div>
  );
};
